<template>
    <b-dropdown
        class="teacher-school-select"
        v-b-tooltip.hover
        toggle-class="teacher-school-select-toggle"
        menu-class="teacher-school-select-menu"
        no-caret
        right
        :title="$t('dashboard.change_school')">
        <template #button-content>
            <i class="fad fa-school"></i>
        </template>

        <b-dropdown-item
            v-for="school in schoolsIn"
            :key="school.id"
            @click.prevent.stop="selectSchool(school)"
            :disabled="school.id === $authUser.school_id">
            {{ school.name }}
        </b-dropdown-item>
    </b-dropdown>
</template>
<script>
export default {
    name: 'design-2021-dashboard-teacher-school-select-component',
    props: {
        schoolsIn: Array,
    },
    data() {
        return {};
    },
    methods: {
        selectSchool(school) {
            this.alert.loading();

            this.axios.get(this.routes.selectSchool(parseInt(school.id))).then(
                (response) => {
                    this.alert.loaded();
                    window.location.href = this.routes.baseUrl();
                },
                (error) => {
                    this.alert.ajaxError(error, this.$t('dashboard.no_school_found_with_this_id'), false);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.teacher-school-select ::v-deep {
    align-self: flex-start;
    width: 35px;

    .teacher-school-select-toggle {
        padding: 6px;
        border-radius: $border-radius-content;
        color: $white;
        width: 35px;
        height: 35px;
        z-index: 10;
        background-color: $primary-darken-alternative;
        border: none;

        &:hover {
            color: $white;
            background-color: darken($primary-darken-alternative, 10%);
        }
    }

    .teacher-school-select-menu {
        border: none;
        border-radius: $border-radius-content;
        padding: map-get($grid-gutter-spacing, 'fifteen');
        box-shadow: 1px 2px 2px $border-color;

        .dropdown-item {
            padding: map-get($grid-gutter-spacing, 'ten');
            font-size: $default-font-size;

            &:hover {
                border-radius: $border-radius-content;
                background-color: $secondary-background-color;
                cursor: pointer;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .teacher-school-select {
        align-self: flex-start;
    }
}
</style>
